const vertices = {};

vertices.pages = function pages(glyphs) {
    const pagesArray = new Float32Array(glyphs.length * 4 /* * 1 */);
    let i = 0;

    glyphs.forEach((glyph) => {
        const id = glyph.data.page || 0;

        // eslint-disable-next-line no-plusplus
        pagesArray[i++] = id;
        // eslint-disable-next-line no-plusplus
        pagesArray[i++] = id;
        // eslint-disable-next-line no-plusplus
        pagesArray[i++] = id;
        // eslint-disable-next-line no-plusplus
        pagesArray[i++] = id;
    });

    return pagesArray;
};

vertices.uvs = function uvs(glyphs, texWidth, texHeight, flipY) {
    const uvsArray = new Float32Array(glyphs.length * 4 * 2);
    let i = 0;

    glyphs.forEach((glyph) => {
        const bitmap = glyph.data;
        const bw = (bitmap.x + bitmap.width);
        const bh = (bitmap.y + bitmap.height);

        // top left position
        const u0 = bitmap.x / texWidth;
        let v1 = bitmap.y / texHeight;
        const u1 = bw / texWidth;
        let v0 = bh / texHeight;

        if (flipY) {
            v1 = (texHeight - bitmap.y) / texHeight;
            v0 = (texHeight - bh) / texHeight;
        }

        // BL
        // eslint-disable-next-line no-plusplus
        uvsArray[i++] = u0;
        // eslint-disable-next-line no-plusplus
        uvsArray[i++] = v1;
        // TL
        // eslint-disable-next-line no-plusplus
        uvsArray[i++] = u0;
        // eslint-disable-next-line no-plusplus
        uvsArray[i++] = v0;
        // TR
        // eslint-disable-next-line no-plusplus
        uvsArray[i++] = u1;
        // eslint-disable-next-line no-plusplus
        uvsArray[i++] = v0;
        // BR
        // eslint-disable-next-line no-plusplus
        uvsArray[i++] = u1;
        // eslint-disable-next-line no-plusplus
        uvsArray[i++] = v1;
    });

    return uvsArray;
};

vertices.positions = function positions(glyphs) {
    const positionsArray = new Float32Array(glyphs.length * 4 * 2);
    let i = 0;

    glyphs.forEach((glyph) => {
        const bitmap = glyph.data;

        // bottom left position
        const x = glyph.position[0] + bitmap.xoffset;
        const y = glyph.position[1] + bitmap.yoffset;

        // quad size
        const w = bitmap.width;
        const h = bitmap.height;

        // BL
        // eslint-disable-next-line no-plusplus
        positionsArray[i++] = x;
        // eslint-disable-next-line no-plusplus
        positionsArray[i++] = y;
        // TL
        // eslint-disable-next-line no-plusplus
        positionsArray[i++] = x;
        // eslint-disable-next-line no-plusplus
        positionsArray[i++] = y + h;
        // TR
        // eslint-disable-next-line no-plusplus
        positionsArray[i++] = x + w;
        // eslint-disable-next-line no-plusplus
        positionsArray[i++] = y + h;
        // BR
        // eslint-disable-next-line no-plusplus
        positionsArray[i++] = x + w;
        // eslint-disable-next-line no-plusplus
        positionsArray[i++] = y;
    });

    return positionsArray;
};

export default vertices;
